var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentMedswiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8182 8.72656C14.2659 8.72656 13.8182 9.17428 13.8182 9.72656V13.8175H9.72729C9.17501 13.8175 8.72729 14.2652 8.72729 14.8175V17.1811C8.72729 17.7334 9.17501 18.1811 9.7273 18.1811H13.8182V22.272C13.8182 22.8243 14.2659 23.272 14.8182 23.272H17.1818C17.7341 23.272 18.1818 22.8243 18.1818 22.272V18.1811H22.2727C22.825 18.1811 23.2727 17.7334 23.2727 17.1811V14.8175C23.2727 14.2652 22.825 13.8175 22.2727 13.8175H18.1818V9.72656C18.1818 9.17428 17.7341 8.72656 17.1818 8.72656H14.8182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentMedswiss);
export default __webpack_public_path__ + "static/media/appointment_medswiss.6f95cdcc0ed52dbbb80de703e5cc5d13.svg";
export { ForwardRef as ReactComponent };